import { User } from '@core/interfaces';
import { CURRENT_ENV } from '@core/configs/env';
import axios from 'axios';

class Auth {
  public static getToken() {
    return localStorage.getItem('token');
  }

  public static setToken(token: string) {
    localStorage.setItem('token', token);
  }

  public static setRefreshToken(refreshToken: string) {
    localStorage.setItem('refreshToken', refreshToken);
  }

  public static clearToken() {
    localStorage.removeItem('token');
    const persist = JSON.parse(localStorage.getItem('persist:root') || '{}');
    localStorage.setItem('persist:root', JSON.stringify(persist));
  }

  public static clearRefreshToken() {
    localStorage.removeItem('refreshToken');
    const persist = JSON.parse(localStorage.getItem('persist:root') || '{}');
    persist.user = '{}';
    persist.upload = '{}';
    localStorage.setItem('persist:root', JSON.stringify(persist));
  }

  public static authenticated() {
    const token = Auth.getToken();
    console.log(token, 'token');
    try {
      if (token === 'seller-api' || token === 'warehouse-api') {
        return true;
      }
      if (!!token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
        );
        let exp = JSON.parse(jsonPayload).exp;
        if (exp * 1000 > new Date().getTime()) return true;
        else {
          let refreshToken = localStorage.getItem('refreshToken');
          if (!refreshToken) return false;
          else {
            let base64UrlRf = refreshToken.split('.')[1];
            let base64Rf = base64UrlRf.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(
              window
                .atob(base64Rf)
                .split('')
                .map(function (c) {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
            );
            let expRf = JSON.parse(jsonPayload).exp;
            if (expRf * 1000 > new Date().getTime()) return true;
            else return false;
          }
        }
      } else {
        return false;
      }
    } catch (e) {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      return false;
    }

    return false;
  }

  public static getUser() {
    const userInfor: User = JSON.parse(
      localStorage.getItem('persist:root') || '{}'
    ).user;
    return userInfor;
  }

  public static clearRole() {
    localStorage.removeItem('role');
  }

  public static getLanguage() {
    return localStorage.getItem('lang');
  }
}

export default Auth;
